import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['area']

  switch({ params: { name } }) {
    this.areaTargets.forEach(el => {
      if (el.dataset.name === name) {
        el.classList.add(el.dataset.klass)
      } else {
        el.classList.remove(el.dataset.klass)
      }
    })
  }
}
